import type { Subcategory } from '../../categories'
import { CARCS, NATERA_TAGS, RARCS } from '../config'

export function getFrequentlyUsedCarcCodes(categoryMetadata: Subcategory['metadata'] | null) {
  if (!categoryMetadata) {
    return []
  }
  return CARCS.filter(
    (c) =>
      (c.phase?.length === 0 || c.phase?.includes(categoryMetadata.phase.label)) &&
      (c.outcome?.length === 0 || c.outcome?.includes(categoryMetadata.outcome.label)) &&
      (c.reason?.length === 0 || c.reason?.includes(categoryMetadata.reason.label)),
  )
    .sort((a, b) => (b.occurrences ?? 0) - (a.occurrences ?? 0))
    .map((c) => c.code)
}

export function getFrequentlyUsedRarcCodes(categoryMetadata: Subcategory['metadata'] | null) {
  if (!categoryMetadata) {
    return []
  }
  return RARCS.filter(
    (c) =>
      (c.phase?.length === 0 || c.phase?.includes(categoryMetadata.phase.label)) &&
      (c.outcome?.length === 0 || c.outcome?.includes(categoryMetadata.outcome.label)) &&
      (c.reason?.length === 0 || c.reason?.includes(categoryMetadata.reason.label)),
  )
    .sort((a, b) => (b.occurrences ?? 0) - (a.occurrences ?? 0))
    .map((c) => c.code)
}

export function getFrequentlyUsedNateraTagCodes(categoryMetadata: Subcategory['metadata'] | null) {
  if (!categoryMetadata) {
    return []
  }
  return NATERA_TAGS.filter(
    (c) =>
      (c.phase.length === 0 || c.phase.includes(categoryMetadata.phase.label)) &&
      (c.outcome.length === 0 || c.outcome.includes(categoryMetadata.outcome.label)) &&
      (c.reason.length === 0 || c.reason.includes(categoryMetadata.reason.label)),
  )
    .sort((a, b) => b.occurrences - a.occurrences)
    .map((c) => c.code)
}
